import { Formik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import { DialogActions } from "@material-ui/core";
import { saveJourneyVisits } from "../../../../../services/crm/salesJourney";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import JourneyVisitForm from "../journeyForm/journeyVisit";
import Swal from "sweetalert2";
import { DateTime } from "luxon";
const VisitForm = ({ journeyID = 0, onReloadVisits, onCloseDialog }) => {
  const [visits, setVisits] = useState({
    data: [
      {
        ID: 0,
        journeyID: journeyID,
        visitType: 1,
        statusID: 1,
        visitTo: "",
        customerID: 0,
        leadID: 0,
        salesCardID: 0,
        salesCardTitle: "",
        planVisitDate: DateTime.now().endOf("day"),
        description: "",
      },
    ],
  });

  const visitsSchema = yup.object().shape({
    data: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        visitTo: yup.string().required("Visit To is Required"),
        customerID: yup.number(),
        leadID: yup.number(),
        salesCardID: yup.number(),
        salesCardTitle: yup.string(),
        planVisitDate: yup.date(),
        description: yup.string(),
      })
    ),
  });
  return (
    <Formik
      initialValues={visits}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={visitsSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Visit ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveJourneyVisits(values.data).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onReloadVisits();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <JourneyVisitForm
            journeyID={journeyID}
            arrayName="data"
            onBlur={handleBlur}
            onChange={handleChange}
            touched={touched}
            errors={errors}
            values={values}
            setFieldValue={setFieldValue}
          />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};

export default VisitForm;
